// extracted by mini-css-extract-plugin
module.exports = {"dayTitle":"panel_dayTitle__2yju2","dayItem":"panel_dayItem__p1znC","ReserveItemBox":"panel_ReserveItemBox__2LFJq","ReserveStatus":"panel_ReserveStatus__7OsSh"};